import { selector } from 'recoil';
import { scenarioState, SkipCondition } from './scenarioState';
import { formState, FormValues } from './formState';

const matchesCondition = (condition: SkipCondition, values: FormValues): boolean => {
  for (const [componentId, value] of Object.entries(condition.condition)) {
    const formValue = values[componentId];
    if (formValue instanceof Array) {
      if (!formValue.includes(value)) {
        return false;
      }
    } else {
      if (formValue !== value) {
        return false;
      }
    }
  }
  return true;
}

const getSkippedItemIds = (conditions: SkipCondition[], values: FormValues): string[] => {
  for (const condition of conditions) {
    if (matchesCondition(condition, values)) {
      return condition.skipScenarioItemIds;
    }
  }
  return [];
}

export const skippedScenarioItemsState = selector({
  key: 'skippedScenarioItems',
  get({get}) {
    const items = get(scenarioState).items;
    const form = get(formState);
    const skippedItemIds = items.flatMap(i => getSkippedItemIds(i.skip, form));
    return items.filter(i => skippedItemIds.includes(i.id));
  }
});

export const usingScenarioItemsState = selector({
  key: 'usingScenarioItems',
  get({get}) {
    const items = get(scenarioState).items;
    const skippedItems = get(skippedScenarioItemsState);
    return items.filter(i => !skippedItems.includes(i));
  }
});
